export default __webpack_public_path__ + "static/media/Pasc img.9fd54d32.png";